import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

import { SessionService } from '../services/session.service';
import { UserService } from '../services/user.service';

import { Contrato } from '../entities/contrato.entity';

import { MenudesktopComponent } from './menudesktop.component';

@Component({
  selector: 'app-menumobile',
  templateUrl: './menumobile.component.html'
})
export class MenumobileComponent implements OnInit {
  public static changeContrato: Subject<boolean> = new Subject();
  public currentUrl: string;
  public contratos: Contrato[];
  public positionselected: number;
  public UserName: string;
  public esPagadorOInactivo: boolean;
  public esFicticio: boolean;

  _opened: boolean = false;

  constructor(private sessionService: SessionService, private router: Router, private userService: UserService) {
    this.positionselected = this.sessionService.PosicionContratoSelected;
    this.sessionService.sessionEvent2.subscribe((esPagadorOInactivo: boolean) => {
      this.esPagadorOInactivo = esPagadorOInactivo;
    });
    MenumobileComponent.changeContrato.subscribe(res => {
      this._opened = !this._opened;
      this.cargaDatos();
    });
  }

  ngOnInit() {
    this.cargaDatos();
  }

  public cargaDatos() {
    if (this.sessionService.contratos !== undefined) {
      this.UserName = this.sessionService.nombre;
      this.contratos = this.sessionService.contratos;
      if (this.sessionService.contratoSelected === undefined) {
        this.sessionService.contratoSelected = this.contratos[0];
        this.sessionService.PosicionContratoSelected = this.positionselected = 0;
      } else {
        this.positionselected = this.sessionService.PosicionContratoSelected;
      }
      this.sessionService.esPagadorOInactivo = this.userService.esPagadorOInactivo(this.sessionService.contratoSelected, this.sessionService.login);
      this.esFicticio = this.sessionService.contratoSelected.Ficticio;
    }
  }

  onMenuToggled() {
    this._opened = !this._opened;
  }

  public ContratoSeleccionado(event) {
    this.sessionService.PosicionContratoSelected = this.positionselected;
    this.sessionService.contratoSelected = this.contratos[this.positionselected];
    this.esPagadorOInactivo = this.sessionService.esPagadorOInactivo;
    this.esFicticio = this.sessionService.contratoSelected.Ficticio;
    MenudesktopComponent.changeContrato.next(true);
  }

  public logout() {
    this.sessionService.logout();
    this.router.navigate(['public/login']);
  }
}
